
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface ClassDetailActionsProps {
  isEvent: boolean;
  onAddStudent: () => void;
}

const ClassDetailActions: React.FC<ClassDetailActionsProps> = ({
  isEvent,
  onAddStudent,
}) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex items-center justify-between">
      <Button variant="outline" onClick={() => navigate(-1)}>
        <ArrowLeft className="mr-2 h-4 w-4" /> 
        Back to {isEvent ? 'Events' : 'Classes'}
      </Button>
      
      <div className="flex space-x-2">
        {!isEvent && (
          <Button 
            variant="default" 
            onClick={onAddStudent}
            className="bg-rosterly-purple hover:bg-rosterly-purple/90"
          >
            Add Student
          </Button>
        )}
      </div>
    </div>
  );
};

export default ClassDetailActions;
